import markUrl from "@/assets/king-terrier-mark.jpeg";
import { Button } from "@/components/ui/button";
import { site } from "@/lib/site";
import { useDocumentTitle } from "@/lib/use-document-title";

export function HomePage() {
    useDocumentTitle(site.titles.home);

    return (
        <section
            className="grid items-center gap-10 px-(--kt-gutter) pt-19 pb-21
                wide:grid-cols-[1fr_clamp(320px,44vw,560px)]"
        >
            {/* Centered as a block below the breakpoint, text still left aligned. */}
            <div className="mx-auto w-full max-w-[520px] wide:mx-0">
                <h1 className="text-[clamp(40px,8vw,76px)] leading-[.98] font-medium tracking-hero text-balance text-white">
                    King Terrier
                    <br />
                    Software
                </h1>
                <p className="mt-6.5 max-w-[400px] text-xl leading-[1.5] text-kt-ink/74">
                    We build software products
                </p>
                <div className="mt-9.5 flex gap-3">
                    <Button asChild variant="brand" size="brand">
                        <a href={site.mailto}>Get in touch</a>
                    </Button>
                </div>
            </div>

            {/* The mark blends against the page's cobalt to hide its baked-in
                background, so no ancestor here may create a stacking context. */}
            <div className="wide:justify-self-end">
                <img
                    src={markUrl}
                    alt="King Terrier mark"
                    width={1254}
                    height={1254}
                    fetchPriority="high"
                    decoding="async"
                    className="mx-auto block w-full max-w-[560px] mix-blend-lighten wide:mx-0"
                />
            </div>
        </section>
    );
}
